import styled from 'styled-components';
import {
  studentPagePadding,
  studentTopbarHeight,
} from '@/v2/constants/StudentLayout';
import Colors from '@/constants/Colors';

export const StyledTaskActivityDetail = styled.div`
  height: 100%;
  position: relative;

  .ant-spin.ant-spin-spinning {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-spin-nested-loading,
  .ant-spin-container {
    height: 100%;

    .task-activity-container {
      display: flex;
      height: 100%;
      min-height: 0;
      min-width: 0;

      .activity-detail {
        flex: 2;
        height: 100%;
        min-height: 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        padding: 16px ${studentPagePadding};
        position: relative;

        .activity-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          position: relative;
          z-index: 1;

          .go-back-link {
            flex-shrink: 0;
            min-width: 24px;
            min-height: 24px;
          }

          .subtitle {
            font-weight: bold;
          }
        }
        .activity-container {
          flex: 1;
          height: 0;
          min-height: 0;
          min-width: 0;
          overflow: hidden;
          position: relative;

          > div {
            height: 100%;
          }

          .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(255, 255, 255, 0.6);
            z-index: 1000;
          }
        }
      }

      .activity-nav {
        flex: 1;
        height: calc(var(--appheight) - ${studentTopbarHeight});
        min-height: 0;
        min-width: 0;
        overflow: hidden;
        box-shadow: 0px 1px 4px ${Colors.boxShadowBlack};
        background-color: white;

        .activity-nav-and-correctness {
          display: flex;
          flex-direction: column;
          height: 100%;
          min-height: 0;
        }
      }
    }
  }
`;
